import {DocumentData} from '@/engine';

export const findIndexedValuesInStore = (data: DocumentData['data'], fieldId: string): string[] => {
  const values: string[] = [];
  for (let index = 0; ; index++) {
    const value = data[`${fieldId}#${index}`];
    if (typeof value !== 'string') break;
    values.push(value);
  }
  return values;
};

export const reorderItemsByKey = <T>(oldKeyValues: string[], freshArray: T[], getKey: (item: T) => string): T[] => {
  const reordered: T[] = [];
  const used = new Set<number>();

  for (const oldKeyValue of oldKeyValues) {
    const index = freshArray.findIndex((item, i) => !used.has(i) && getKey(item) === oldKeyValue);
    if (index >= 0) {
      reordered.push(freshArray[index]);
      used.add(index);
    }
  }

  freshArray.forEach((item, index) => {
    if (!used.has(index)) reordered.push(item);
  });

  return reordered;
};
